import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type UpdateAttributeByIdRequest = InferRequestType<
  (typeof apiClient.attributes)[':attributeId']['$patch']
>['json']
type UpdateAttributeByIdResponse = InferResponseType<
  (typeof apiClient.attributes)[':attributeId']['$patch']
>

export type UseUpdateAttributeByIdArgs = {
  attributeId: string
  data: UpdateAttributeByIdRequest
}

export const useUpdateAttributeById = (
  options?: UseMutationOptions<
    UpdateAttributeByIdResponse,
    Error,
    UseUpdateAttributeByIdArgs
  >
) =>
  useMutation({
    mutationFn: async (variables) => {
      return await apiClient.attributes[':attributeId']
        .$patch({
          param: { attributeId: variables.attributeId },
          json: variables.data,
        })
        .then((r) => formatClientResponse(r))
    },
    mutationKey: ['attribute-update'],
    ...options,
  })
